export const NotificationEventType = {
    MessageFromAccountantToCustomer: '0',
    MessageFromSupportToCustomer: '1',
    CompanyAccountsAwaitingCustomerApproval: '2',
    CompanyAccountsFiled: '3',
    CompanyAccountsComplete: '4',
    CompanyBookLegalizationAwaitingCustomerApproval: '5',
    CompanyBookLegalizationFiled: '6',
    CompanyBookLegalizationComplete: '7',
    CompanyTaxReturnAwaitingCustomerApproval: '8',
    CompanyTaxReturnFiled: '9',
    QuarterlyTaxReturnAwaitingCustomerApproval: '10',
    QuarterlyTaxReturnFiled: '11',
    QuarterlyTaxReturnsAnnualSummaryFiled: '12',
    TaxReturnAwaitingCustomerApproval: '13',
    TaxReturnFiled: '14',
} as const
